

















































































































import { Mixins, Component, Watch } from "vue-property-decorator";
import Page from "@/views/Page.vue";
import PageSection from "@/components/PageSection.vue";
import SectionField from "@/components/SectionField.vue";
import DisplayErrors from "@/components/DisplayErrors.vue";
import { RegisterHttp } from "@/utils/Decorators";
import RequestData from "@/store/types/RequestData";
import UsersMixin from "@/mixins/http/UsersMixin";
import { UserPayload } from "@/models/User";
import IUser from "@/models/interfaces/IUser";
import { showToast } from "@/utils/RailsRoutes";
import UserRoleSelect from "@/components/User/RoleSelect.vue";
import UserTitleSelect from "@/components/User/TitleSelect.vue";
import UserSalesDepartmentsSelect from "@/components/User/SalesDepartmentsSelect.vue";
import { capitalize } from "@/utils/Typography";
import withErrors from "@/directives/WithErrors";

const saveTag = "save_user";
const loadTag = "get_user";

@Component({
  components: {
    Page,
    PageSection,
    SectionField,
    DisplayErrors,
    UserRoleSelect,
    UserTitleSelect,
    UserSalesDepartmentsSelect,
  },
  directives: {
    withErrors,
  },
})
export default class UserForm extends Mixins(UsersMixin) {
  isNew = true;

  get saveTagProxy() {
    return saveTag;
  }

  get loading() {
    return this.saveRequest?.loading || false;
  }

  @RegisterHttp(saveTag) readonly saveRequest!: RequestData;
  @RegisterHttp(loadTag) readonly loadRequest!: RequestData;
  item: UserPayload = null;

  onRoleChanged(role: string) {
    this.item.role = role;
  }

  onTitleChanged(title: string) {
    this.item.title = title;
  }

  onSalesDepartmentChanged(id: string) {
    this.item.salesUserId = id;
  }

  @Watch("item.firstName", { deep: true })
  onFirstNameChanged(value: string, oldValue: string | undefined) {
    if (value && oldValue) {
      this.item.firstName = capitalize(value);
    }
  }

  @Watch("item.lastName", { deep: true })
  onLastChanged(value: string, oldValue: string | undefined) {
    if (value && oldValue) {
      this.item.lastName = capitalize(value);
    }
  }

  get title() {
    return `${this.isNew ? "Add" : "Edit"} user`;
  }

  async created() {
    this.item = new UserPayload();
    this.item.companyId = this.$route.params.id;
    await this.$nextTick();
    if (this.$route.params.user_id) {
      await this.edit(Number.parseInt(this.$route.params.user_id));
    } else {
      this.create(this.$route.params.id);
    }
  }

  async edit(userId: number) {
    const user: IUser = await this.getUser(userId, loadTag);
    this.isNew = false;
    this.item = new UserPayload();
    this.item.fromData(user);
  }

  create(companyId) {
    this.isNew = true;
  }

  async save() {
    try {
      const user = this.isNew
        ? await this.createUser(this.item, saveTag)
        : await this.updateUser(this.item, saveTag);
      const emitTag = this.isNew ? "created" : "updated";
      this.$emit(emitTag, user);
      showToast("User saved successfully!");
      this.$router.push({ name: "company_show_users" });
    } catch (err) {
      if (err.response?.status !== 422) {
        showToast("An error occurred while saving user: " + err, {
          type: "error",
        });
      }
    }
  }
}
